import { useState } from 'react';
import { Route, useHistory, Switch } from 'react-router-dom';
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import AppNav from '../AppNav';
import Login from './Login';
import { oktaEnvAuthConfig, oktaEnvSignInConfig } from './Config';

const AppWithRouterAccess = () => {
  const history = useHistory();

  const environment = process.env.REACT_APP_ENV;

  const oktaAuthEnv = oktaEnvAuthConfig[environment];
  const oktaSignInEnv = oktaEnvSignInConfig[environment];
  const oktaAuth = new OktaAuth(oktaAuthEnv);
  const [isLoggedIn, setLoginInfo] = useState(
    JSON.parse(localStorage.getItem('okta-token-storage')),
  );

  const customAuthHandler = () => {
    history.push('/');
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(
      toRelativeUrl(originalUri || '/controlpoint', window.location.origin),
    );
    setLoginInfo(JSON.parse(localStorage.getItem('okta-token-storage')));
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={customAuthHandler}
      restoreOriginalUri={restoreOriginalUri}
    >
      {isLoggedIn !== null && (
        <Route
          path="/controlpoint"
          render={() => <AppNav isLoggedIn={isLoggedIn} />}
        />
      )}
      <Switch>
        <Route path="/" render={() => <Login config={oktaSignInEnv} />} />
        <Route path="/" component={LoginCallback} />
      </Switch>
    </Security>
  );
};
export default AppWithRouterAccess;
